import { CardContent, Menu, MenuItem, Button, Box } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSimulations } from "contexts/SimulationsContext";
import { useRuns } from "contexts/RunsContext";
import CreateVegSimulation from "./CreateVegSimulation";
import usePage from "hooks/usePage";
import CreateUrbanSimulation from "./CreateUrbanSimulation";

export default function CreateSimulation() {
  const { isUrbanPage, projectId, runId } = usePage();
  const { isCreatingSimulation, setNewRunName, runs } = useRuns();
  const { createSimulation, clearSimulation } = useSimulations();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const currSimulation = (runs || []).find((run) => run.id === runId);

  const removeCurrRun = () => {
    navigate(`/project/${projectId}${isUrbanPage ? "/urban" : ""}`);
  };

  if (!isCreatingSimulation) {
    return (
      <CardContent
        sx={{
          "&:last-child": {
            paddingBottom: "16px",
          },
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            id="new-simulation-button"
            variant="contained"
            size="large"
            fullWidth
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={(event) => {
              if (isUrbanPage) {
                removeCurrRun();
                createSimulation("urban");
              } else {
                setAnchorEl(event.currentTarget);
              }
            }}
            sx={{
              width: "160px",
            }}
          >
            New Simulation
          </Button>
          <Menu
            id="select-new-simulation"
            anchorEl={anchorEl}
            open={open}
            onClose={() => {
              setAnchorEl(null);
            }}
            MenuListProps={{
              sx: {
                width: 250,
              },
            }}
          >
            <MenuItem
              onClick={() => {
                setAnchorEl(null);
                setNewRunName(currSimulation?.name || "");
                removeCurrRun();
                createSimulation("existing");
              }}
            >
              Existing Ignition Lines
            </MenuItem>
            <MenuItem
              onClick={() => {
                setAnchorEl(null);
                removeCurrRun();
                createSimulation("new");
              }}
            >
              New Ignition Lines
            </MenuItem>
          </Menu>
        </Box>
      </CardContent>
    );
  }

  return (
    <Box>
      <Box
        sx={{
          position: "absolute",
          zIndex: 1,
          bottom: 0,
          left: 0,
          right: 0,
          top: "100px",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
        onClick={() => {
          setNewRunName("");
          clearSimulation();
        }}
      />
      {isUrbanPage ? <CreateUrbanSimulation /> : <CreateVegSimulation />}
    </Box>
  );
}
